import React from 'react'
import TextLoadingBox from '../Typography/TextLoadingBox'
import Group from 'components/utils/Group'

interface Props {
  size: 'S' | 'L'
}

function PriceRowPointsSpendLoadingSkeleton(props: Props) {
  const { size } = props
  return <Group direction="horizontal" gap={2} verticalAlign="start">
    <TextLoadingBox typography={size === 'S' ? 'heading6' : 'heading4'} width="4ch" />
    <TextLoadingBox typography="body-small" width="3ch" />
  </Group>
}

export default PriceRowPointsSpendLoadingSkeleton
